import type { LeadRequest } from '../domain/leadRequest.types'

export class LeadRequestSubmissionError extends Error {
  constructor(message = 'No pudimos enviar tu solicitud. Inténtalo de nuevo en unos momentos.') {
    super(message)
    this.name = 'LeadRequestSubmissionError'
  }
}

export async function submitLeadRequest(request: LeadRequest, turnstileToken: string, website: string) {
  const response = await fetch('/api/lead', {
    method: 'POST',
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({ ...request, website, turnstileToken }),
  })

  if (!response.ok) {
    let message: string | undefined
    try {
      const payload = (await response.json()) as { message?: string }
      message = payload.message
    } catch {
      // Keep a generic user-safe error message.
    }
    throw new LeadRequestSubmissionError(message)
  }

  return (await response.json()) as { success: true; requestId: string }
}
